import { CustomTooltip } from '@fountain/fountain-ui-components';
import { Button, IconButton } from '@material-ui/core';
import React, { FC } from 'react';

import { useHoverActionStyles as useStyles } from '../styles';

export type ActionVariant = 'icon' | 'text';

export interface ActionProps {
  ariaLabel: string;
  children?: React.ReactNode;
  onClick: (event: React.BaseSyntheticEvent) => void;
  tooltipTitle:
    | boolean
    | React.ReactChild
    | React.ReactFragment
    | React.ReactPortal;
}

export const IconAction: FC<ActionProps> = ({
  ariaLabel,
  children,
  onClick,
  tooltipTitle,
}) => {
  const styles = useStyles();
  return (
    <CustomTooltip dense title={tooltipTitle}>
      <IconButton
        className={styles.iconVariant}
        aria-label={ariaLabel}
        onClick={onClick}
      >
        {children}
      </IconButton>
    </CustomTooltip>
  );
};

export const TextAction: FC<ActionProps> = ({
  ariaLabel,
  children,
  onClick,
}) => {
  const styles = useStyles();
  return (
    <Button
      aria-label={ariaLabel}
      className={styles.textVariant}
      onClick={onClick}
      variant="text"
    >
      {children}
    </Button>
  );
};

export interface HoverActionProps extends ActionProps {
  variant?: ActionVariant;
}
export const HoverAction: FC<HoverActionProps> = ({ variant, ...props }) => {
  switch (variant) {
    case 'text':
      return <TextAction {...props} />;
    case 'icon':
    default:
      return <IconAction {...props} />;
  }
};
